module.exports = __webpack_public_path__ + "img/io-3.834ac26a.jpg";